export const ServiceWorkerReg = new class extends EventTarget {
    private _registration: ServiceWorkerRegistration|undefined;

    constructor() {
        super();
        this.checkForUpdate = this.checkForUpdate.bind(this);
    }

    register() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('./sw.js').then(reg => {
                this._registration = reg;
                let isRefreshing: boolean = false;

                // check for service worker updates every 10 minutes
                setInterval(() => {this.checkForUpdate(); }, 10*60*1000);

                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    console.log('controllerchange');
                    if (isRefreshing) return;
                    this.dispatchEvent(new CustomEvent('update-available'));
                    isRefreshing = true;
                });
            });
        }
    }

    async checkForUpdate() {
        if (this._registration) {
            await this._registration.update();
        }
    }
}

